import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CalculationKeynameEnum } from '../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';

export abstract class ImportModalBase {
  public calculationKeyname: CalculationKeynameEnum;

  constructor(public readonly activeModal: NgbActiveModal) {
  }
}
